export function eventLabel(t?: string | null): string {
  if (!t) return 'Event';
  const map: Record<string, string> = {
    goal: 'Goal',
    card: 'Card',
    own_goal: 'Own goal',
    save: 'Save',
    shot: 'Shot',
    seven_meter: '7 meter',
    penalty_received: 'Penalty received',
    seven_meter_shot: '7m shot',
    penalty: 'Penalty',
    red_card: 'Red',
    yellow_card: 'Yellow',
    second_yellow: 'Second yellow',
    substitution: 'Substitution',
    two_minute: '2 minutes',
  };
  const known = map[t];
  if (known) return known;
  const words = String(t).replace(/_/g, ' ').trim();
  if (!words) return 'Event';
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** Stored event game clock (8:09), not clip duration. */
export function eventGameClock(ev: { minute?: number | null; second?: number | null }): string | null {
  if (ev.minute == null && ev.second == null) return null;
  return `${ev.minute ?? 0}:${String(ev.second ?? 0).padStart(2, '0')}`;
}

export function formatClipClock(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return '0:00';
  const s = Math.round(ms / 1000);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${String(r).padStart(2, '0')}`;
}
